import apiService from 'library/api-service';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getUsedBanks = createAsyncThunk('getUsedBanks', async () => {
  const response = await apiService.getUsedBanks();

  return { usedBanks: response.data };
});

const usedBanksActions = { getUsedBanks };

export default usedBanksActions;
